module.exports = __webpack_public_path__ + "img/profileBG_mask.b976e953.png";